import { render } from "./huoguogo.vue?vue&type=template&id=3238f912&scoped=true"
const script = {}

import "./huoguogo.vue?vue&type=style&index=0&id=3238f912&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3238f912"]])

export default __exports__